export default __webpack_public_path__ + "static/media/wallpaper1.b0fa8e1d.jpeg";